import { Injectable } from '@angular/core';
import { TileComfortComponent } from '../../../components/tile/tile-comfort/tile-comfort';
import type { CustomTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileComfortProvider implements CustomTileProvider {
    fillTileDescription(): CustomTileModel {
        throw Error('Not implemented');
    }

    getTileComponent() {
        return TileComfortComponent;
    }
}
